import { Definition } from './index';

export default {
  back: 'Back to all projects',
  hint: ['You can get ', 'more information', 'about any experience by clicking on it.'],
} as Definition;
